import { ReactNode, createContext } from 'react';
import useLocalStorage from '~/hooks/useLocalStorage';
import {
  CompanyTrendsSearchParams,
  CompanyTrendsSearchParamsContextState,
} from './types/company-trends/searchParams';
import { useConstants } from './constants/company-trends/constants';

const initialState: CompanyTrendsSearchParamsContextState = {
  defaultValues: {} as CompanyTrendsSearchParams,
  searchParams: {} as CompanyTrendsSearchParams,
  setSearchParams: () => {},
};

const CompanyTrendsSearchParamsContext = createContext(initialState);

type CompanyTrendsSearchParamsProviderProps = {
  children: ReactNode;
};

function CompanyTrendsSearchParamsProvider({ children }: CompanyTrendsSearchParamsProviderProps) {
  const { defaultValues } = useConstants();

  const [searchParams, setSearchParams] = useLocalStorage<CompanyTrendsSearchParams>(
    'searchParams:companyTrends',
    defaultValues
  );

  return (
    <CompanyTrendsSearchParamsContext.Provider
      value={{ searchParams, setSearchParams, defaultValues }}
    >
      {children}
    </CompanyTrendsSearchParamsContext.Provider>
  );
}

export { CompanyTrendsSearchParamsProvider, CompanyTrendsSearchParamsContext };
